import Web3 from "web3";
import BigNumber from "bignumber.js";

let web3 = new Web3();

export const WEB3 = {
  Contract: (abiCode) => {
    return new web3.eth.Contract(abiCode);
  },
  isAddress: (address) => {
    return web3.utils.isAddress(address);
  },
  hexToBytes: (hex) => {
    const hexToBytes = web3.utils.hexToBytes(hex);
    return Array.from(hexToBytes);
  },
  bytesToHex: (bytes) => {
    return web3.utils.bytesToHex(bytes);
  },
  toWei: (amount) => {
    if (!amount) {
      return web3.utils.toWei("0", "ether"); // 기본값 0을 ether로 변환
    }
    return web3.utils.toWei(amount, "ether"); // amount가 존재하면 ether 단위로 변환
  },

  fromWei: (wei) => {
    try {
      return web3.utils.fromWei(wei, "ether");
    } catch (e) {
      return "-";
    }
  },
  toHex: (decimal) => {
    return web3.utils.toHex(decimal);
  },
  toDecimal: (hex) => {
    return web3.utils.toDecimal(hex);
  },
  fromDecimal: (number) => {
    return web3.utils.fromDecimal(number);
  },
  isHex: (hex) => {
    return web3.utils.isHex(hex);
  },
  toBN: (amount) => {
    return new BigNumber(amount);
  },

  add: (amount1, amount2) => {
    const BN1 = new BigNumber(amount1);
    const BN2 = new BigNumber(amount2);
    return BN1.plus(BN2).toFixed();
  },

  sub: (amount1, amount2) => {
    const BN1 = new BigNumber(amount1);
    const BN2 = new BigNumber(amount2);
    return BN1.minus(BN2).toFixed();
  },
  mul: (amount1, amount2) => {
    const BN1 = new BigNumber(amount1);
    const BN2 = new BigNumber(amount2);
    return BN1.times(BN2).toFixed(); // mul() -> times()
  },
  div: (amount1, amount2) => {
    const BN1 = new BigNumber(amount1);
    const BN2 = new BigNumber(amount2);
    return BN1.div(BN2).toFixed(); // div() -> div()
  },

  addElements: (el) => {
    const result = el.reduce((acc, cur) => {
      const BN_acc = new BigNumber(acc);
      const BN_cur = new BigNumber(cur);
      return BN_acc.plus(BN_cur).toFixed(); // add() -> plus()
    }, 0);
    return result;
  },

  subElements: (el) => {
    const result = el.reduce((acc, cur) => {
      const BN_acc = new BigNumber(acc);
      const BN_cur = new BigNumber(cur);
      return BN_acc.minus(BN_cur).toFixed(); // sub() -> minus()
    });
    return result;
  },

  mulElements: (el) => {
    const result = el.reduce((acc, cur) => {
      const BN_acc = new BigNumber(acc);
      const BN_cur = new BigNumber(cur);
      return BN_acc.times(BN_cur).toFixed(); // mul() -> times()
    }, 1);
    return result;
  },

  divElements: (el) => {
    const result = el.reduce((acc, cur) => {
      const BN_acc = new BigNumber(acc);
      const BN_cur = new BigNumber(cur);
      return BN_acc.div(BN_cur).toFixed(); // div() -> div()
    }, 1);
    return result;
  },
  gt: (amount1, amount2) => {
    const BN1 = new BigNumber(amount1);
    const BN2 = new BigNumber(amount2);
    return BN1.isGreaterThan(BN2); // gt() -> isGreaterThan()
  },

  lt: (amount1, amount2) => {
    const BN1 = new BigNumber(amount1);
    const BN2 = new BigNumber(amount2);
    return BN1.isLessThan(BN2); // lt() -> isLessThan()
  },

  lte: (amount1, amount2) => {
    const BN1 = new BigNumber(amount1);
    const BN2 = new BigNumber(amount2);
    return BN1.isLessThanOrEqualTo(BN2); // lte() -> isLessThanOrEqualTo()
  },

  // account
  createAccount: () => {
    return web3.eth.accounts.create();
  },
  encryptKeystore: async (privateKey, password) => {
    return await web3.eth.accounts.encrypt(privateKey, password);
  },
  decryptKeystore: async (keystoreJson, password) => {
    return await web3.eth.accounts.decrypt(keystoreJson, password);
  },
  privateKeyToAddress: (privateKey) => {
    return web3.eth.accounts.privateKeyToAccount(privateKey);
  },
};
